import { SystemConfig } from '../types/SystemConfigTypes'

export const isSystemConfigEnabled = (config: SystemConfig | undefined, clientId: string) => {
  if (!config) return false
  if ((config.disallowedClientIds ?? []).includes(clientId)) return false
  return config.defaultEnabled === true || (config.allowedClientIds ?? []).includes(clientId)
}
